module.exports = __webpack_public_path__ + "img/social-icon.c4d9f231.svg";